import { Invoice } from '../../models/Invoice';
import { createReducer, on } from '@ngrx/store';
import * as InvoiceActions from './invoice.actions';

export interface InvoiceState {
  invoices: Invoice[];
  currentInvoice: Invoice | null;
}

export const initialState: InvoiceState = {
  invoices: [],
  currentInvoice: null,
};

export const invoiceReducer = createReducer(
  initialState,
  on(InvoiceActions.getInvoices, (state) => ({ ...state, loading: true })),
  on(InvoiceActions.getInvoicesSuccess, (state, { invoices }) => ({
    ...state,
    loading: false,
    invoices,
  })),
  on(InvoiceActions.getInvoicesFailure, (state) => ({
    ...state,
    loading: false,
  })),
  on(InvoiceActions.selectInvoice, (state) => ({ ...state, loading: true })),
  on(InvoiceActions.selectInvoiceSuccess, (state, { invoice }) => ({
    ...state,
    currentInvoice: invoice,
    loading: false
  })),
  on(InvoiceActions.deselectInvoice, (state) => ({
    ...state,
    currentInvoice: null,
  }))
);
